import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { requestAuthentication } from '../../../actions/authentication';
import { onConsultantCianCloseNoAuth, requestChat } from '../../../actions/consultantCianChat';
import { Dispatch } from 'shared/common/state';
import { getUser } from 'shared/selectors/user';

export function useConsultantCianChat() {
  const dispatch: Dispatch = useDispatch();
  const user = useSelector(getUser);

  const openChat = React.useCallback(() => {
    if (!user.isAuthenticated) {
      dispatch(
        requestAuthentication({
          onSuccess: () => requestChat(),
          onCloseNoAuth: onConsultantCianCloseNoAuth(),
        }),
      );

      return;
    }

    dispatch(requestChat());
  }, [dispatch, user]);

  return React.useMemo(
    () => ({
      openChat,
    }),
    [openChat],
  );
}
